import { render } from "./LearningPlansComponent.vue?vue&type=template&id=0d4d803a"
import script from "./LearningPlansComponent.vue?vue&type=script&lang=js"
export * from "./LearningPlansComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__